export const DASHBOARD_TABS = [
	{ id: "home", label: "Home" },
	{ id: "jobs", label: "Jobs" },
	{ id: "branding", label: "Branding" },
	{ id: "activity", label: "Activity" },
	{ id: "billing", label: "Billing" },
];

export const DEFAULT_BANNER_COLOR = "#0A6FE2";

export const SETUP_CHECKLIST_ITEMS = [
	{
		id: "company_description",
		label: "Add company description",
		description: "Introduce your company to candidates in the public profile preview.",
		targetTab: "branding",
	},
	{
		id: "contact_info",
		label: "Add contact info",
		description: "Add website, email, phone, or address for candidates to reach you.",
		targetTab: "branding",
	},
	{
		id: "social_links",
		label: "Add social links",
		description: "Connect LinkedIn, Twitter, and other public profiles.",
		targetTab: "branding",
	},
	{
		id: "customize_banner",
		label: "Customize banner",
		description: "Choose the banner color shown on your company profile.",
		targetTab: "branding",
	},
	{
		id: "why_work_here",
		label: 'Add "Why work here" benefits',
		description: "Highlight perks, culture, and reasons candidates should join.",
		targetTab: "branding",
	},
];

export const PLAN_LABELS = {
	starter: "Starter",
	corporate: "Corporate",
	enterprise: "Enterprise",
};

export const PLAN_TIERS = [
	{
		id: "starter",
		name: "Starter",
		price: "49,000",
		period: "TZS / month",
		tagline: "Essential Toolkit",
		description: "For small teams that want a polished company presence and core hiring visibility.",
		features: [
			{ text: "Verified employer profile", included: true },
			{ text: "Company dashboard access", included: true },
			{ text: "Open roles management", included: true },
			{ text: "Branding basics", included: true },
			{ text: "Activity timeline", included: false },
			{ text: "Advanced branding controls", included: false },
		],
	},
	{
		id: "corporate",
		name: "Corporate",
		price: "89,000",
		period: "TZS / month",
		tagline: "Grow Your Reach",
		description: "For active employers that need stronger branding, more team flexibility, and more insights.",
		popular: true,
		features: [
			{ text: "Everything in Starter", included: true },
			{ text: "Activity timeline", included: true },
			{ text: '"Why work here" section', included: true },
			{ text: "Priority refresh actions", included: true },
			{ text: "Advanced analytics", included: false },
			{ text: "Custom domain", included: false },
		],
	},
	{
		id: "enterprise",
		name: "Enterprise",
		price: "229,000",
		period: "TZS / month",
		tagline: "Own Your Identity",
		description: "For organizations hiring continuously and wanting a fully branded employer experience.",
		enterprise: true,
		features: [
			{ text: "Everything in Corporate", included: true },
			{ text: "Expanded branding controls", included: true },
			{ text: "Enhanced analytics", included: true },
			{ text: "Custom domain / subdomain", included: true },
			{ text: "Premium support lane", included: true },
			{ text: "Dedicated account management", included: true },
		],
	},
];

export const BILLING_HISTORY = [
	{ invoice: "INV-2026-001", date: "Jan 12, 2026", status: "paid", amount: "49,000 TZS", plan: "Starter" },
	{ invoice: "INV-2025-012", date: "Dec 12, 2025", status: "paid", amount: "49,000 TZS", plan: "Starter" },
	{ invoice: "INV-2025-011", date: "Nov 12, 2025", status: "paid", amount: "49,000 TZS", plan: "Starter" },
];

export const BRAND_COLORS = ["#0A6FE2", "#0055B8", "#0F766E", "#0F7C39", "#A8550A", "#BE123C", "#6D28D9", "#334155"];

export const TEMPLATE_OPTIONS = [
	{ id: "classic", name: "Classic", description: "Balanced layout with a prominent profile summary." },
	{ id: "modern", name: "Modern", description: "A stronger color-led presentation with denser content blocks." },
	{ id: "minimal", name: "Minimal", description: "Simplified layout with quieter chrome and lighter framing." },
];

export const STORAGE_KEYS = {
	buildDashboardStateKey(companyId) {
		return `dproz_company_dashboard_state:${companyId}`;
	},
	buildUpsellKey(companyId) {
		return `dproz_company_dashboard_upsell:${companyId}`;
	},
	buildActivityDateRangeKey(companyId) {
		return `dproz_company_dashboard_activity_range:${companyId}`;
	},
};

export const UPSSELL_RESHOW_DAYS = 7;
